import Offers from './offers';
export default Offers;
